<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <!--        普货仓库-->
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="250314"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="800px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <div>
          <el-form label-width="100px" label-position="right" style="display: flex">
            <el-form-item :label="$t('CargoMsg.Cargo_WarehouseName')" required>
              <el-input v-model="editDialog.form.warehouseName" no="warehouseName" style="width: 140px;" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_WarehouseCode2')" required>
              <el-input v-model="editDialog.form.warehouseCode" no="warehouseCode" style="width: 140px;" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_AirportCode')" required>
              <cargo-advance-select
                no="airportCode"
                :select-type="selectTypeNames.basic_data_Airport"
                :custom-label="(item)=>`${item.code}`"
                :filter-tag-names="['code']"
                filterable
                :tag-name="'code'"
                :tag-value="'code'"
                style="width: 140px;"
                :show-custom-label-in-option="true"
                :default-value="editDialog.form.airportCode"
                @parentCallBack="p=>{editDialog.form.airportCode=p.value}"
              />
            </el-form-item>
          </el-form>
          <el-form label-width="100px" label-position="right" style="display: flex">
            <el-form-item :label="$t('CargoMsg.Cargo_OrderType')" required>
              <el-select v-model="editDialog.form.orderType" no="orderType" style="width: 140px;">
                <el-option label="AE" value="AE" />
                <el-option label="AI" value="AI" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_SecurityCheckMachineWidthLimit')" required>
              <auto-number-input
                v-model="editDialog.form.securityMachineWidth"
                no="securityMachineWidth"
                :precision="0"
                :enforce-min="true"
                style="width: 140px;"
                :min="0"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_SecurityCheckMachineHeightLimit')" required>
              <auto-number-input
                v-model="editDialog.form.securityMachineHeight"
                no="securityMachineHeight"
                :precision="0"
                style="width: 140px;"
                :enforce-min="true"
                :min="0"
              />
            </el-form-item>
          </el-form>
          <el-form label-width="100px" label-position="right" style="display: flex">
            <el-form-item :label="$t('CargoMsg.Cargo_WarehouseAddress')">
              <el-input v-model="editDialog.form.warehouseAddress" no="warehouseAddress" style="width: 140px;" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_WarehouseType')" required>
              <el-select v-model="editDialog.form.warehouseType" filterable clearable style="width: 140px;">
                <el-option v-for="(item,index) in WAREHOUSE_TYPE_LIST" :key="index" :label="item.chineseName" :value="item.code" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_RemarksInfo')">
              <el-input v-model="editDialog.form.remarks" no="remarks" style="width: 140px;" />
            </el-form-item>
          </el-form>
          <el-form label-width="100px" label-position="right" style="display: flex">
            <el-form-item :label="$t('CargoMsg.Cargo_RecipientContact')">
              <el-input v-model="editDialog.form.receiverContact" no="receiverContact" style="width: 140px;" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_RecipientContactPhone')">
              <el-input v-model="editDialog.form.receiverPhone" no="receiverPhone" style="width: 140px;" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DeliveryMap')">
              <u style="color:#46a6ff;cursor:pointer" @click="uploadAttachment(editDialog.form.uuid)">{{ this.$t('Partners.uploadFile') }}</u>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <cargo-ag-grid
        no="grid"
        :grid-options="edit.editGridOptions"
        :column-defs="edit.editColumnDefs"
        :row-data="edit.editRowData"
        style="width: 100%;"
        @gridReady="params=>{edit.editGridApi=params.api}"
      />
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- 摄像头配置 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="cameraDialog.visible"
      :title="cameraDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <div style="display: flex">
          <el-form label-width="80px" label-position="right">
            <el-form-item :label="$t('CargoMsg.Cargo_MonitoringInterface')">
              <el-select v-model="cameraDialog.form.cameraInterfaceType" no="cameraInterfaceType">
                <el-option :label="$t('CargoMsg.Cargo_MonitoringInterface1')" :value="'1'" />
              </el-select>
            </el-form-item>
            <el-form-item label="AppKey">
              <el-input v-model="cameraDialog.form.cameraAppKey" no="cameraAppKey" />
            </el-form-item>
          </el-form>
          <el-form label-width="80px" label-position="right">
            <el-form-item :label="$t('CargoMsg.Cargo_DeviceNumber')">
              <el-input v-model="cameraDialog.form.cameraDeviceNumber" no="cameraDeviceNumber" />
            </el-form-item>
            <el-form-item label="Secret">
              <el-input v-model="cameraDialog.form.cameraSecret" no="cameraSecret" />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <cargo-ag-grid
        no="cameraGrid"
        :grid-options="cameraC.gridOptions"
        :column-defs="cameraC.columnDefs"
        :row-data="cameraC.rowData"
        style="width: 100%;"
        @gridReady="params=>{cameraC.gridApi=params.api}"
      />
      <span slot="footer">
        <el-button no="save" type="primary" @click="cameraSave">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      </span>
    </el-dialog>

    <!-- 文件上传对话框 -->
    <cargo-file-upload-dialog
      :visible.sync="fileUpload.visible"
      :title="fileUpload.title"
      :document-category="fileUpload.documentCategory"
      :business-id="fileUpload.businessId"
      :show-file-category="fileUpload.showFileCategory"
      :lob="fileUpload.lob"
      :parameters="fileUpload.parameters"
    />
  </div>
</template>

<script>
import { getAirportCargoTerminalList, saveAirportCargoTerminal, delAirportCargoTerminal } from '@/api/basicData/airportCargoTerminal'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage } from '@/utils/commonUtil'
import { getUuid } from '@/utils'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import { WAREHOUSE_TYPE_LIST } from '@/class/cargo/model/parameters/SystemConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { serial } from '@/components/Cargo/FrontEndWarehouse/components/util/serial/getWeight'
import cargoFileUploadDialog from '@/components/Cargo/Common/cargoFileUploadDialog.vue'

export default {
  name: 'GeneralCargoWarehouse',
  components: { cargoFileUploadDialog, AutoNumberInput, cargoAdvanceSelect },
  data() {
    return {
      filter: {
        likeName: '',
        dataType: 1,
        pageNum: 1,
        pageSize: 50
      },
      WAREHOUSE_TYPE_LIST,
      selectTypeNames: TYPE_NAMES,
      addKey: 'addTerminal_',
      addScaleKey: 'addScale_',
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      fileUpload: {
        visible: false,
        title: this.$t('Partners.uploadFile'),
        documentCategory: 200,
        businessId: '',
        showFileCategory: true,
        lob: 'AE',
        parameters: {
          companyKey: '',
          uuid: '',
          documentType: '',
          createdBy: 0
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarehouseCode2'),
          field: 'warehouseCode',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarehouseName'),
          field: 'warehouseName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AirportCode'),
          field: 'airportCode',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OrderType'),
          field: 'orderType',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarehouseAddress'),
          field: 'warehouseAddress',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RecipientContact'),
          field: 'receiverContact',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RecipientContactPhone'),
          field: 'receiverPhone',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SecurityCheckMachineWidthLimit'),
          field: 'securityMachineWidth',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SecurityCheckMachineHeightLimit'),
          field: 'securityMachineHeight',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarehouseType'),
          field: 'warehouseType',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.WAREHOUSE_TYPE_LIST)
          }
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          dataType: 1,
          warehouseName: '',
          warehouseCode: '',
          airportCode: '',
          warehouseType: 0,
          orderType: '',
          securityMachineWidth: 0,
          securityMachineHeight: 0,
          warehouseAddress: '',
          deliveryMapUrl: '',
          receiverContact: '',
          receiverPhone: '',
          remarks: ''
        }
      },
      documentManage: new DocumentManage(),
      edit: {
        editGridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor
          },
          context: {
            componentParent: this
          }
        },
        editColumnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_WeighbridgeNumber'),
            field: 'scaleIdentifier',
            editable: true,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: false,
              inputProps: {
                maxLength: 10
              }
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_WeighbridgeBaudRate'),
            field: 'baudRate',
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0')
            },
            editable: true,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                controls: false,
                precision: 0
              }
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Checksum'),
            field: 'parityBit',
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0')
            },
            editable: true,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                controls: false,
                precision: 0
              }
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_PhotoTaken'),
            field: 'autoPhotoTaking',
            cellRenderer: params => {
              return params.value ? this.$t('CargoMsg.Cargo_Yes') : this.$t('CargoMsg.Cargo_No')
            },
            editable: true,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CameraConfiguration'),
            field: 'autoPhotoTaking',
            cellRenderer: params => {
              const onCameraConfiguration = this.documentManage.getPath('onCameraConfiguration')
              return `<button><div onclick="${onCameraConfiguration}('${params.data.uuid}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_Config')}</div></button>`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_WeighbridgeTest'),
            field: 'autoPhotoTaking',
            cellRenderer: params => {
              const onWeighbridgeTest = this.documentManage.getPath('onWeighbridgeTest')
              return `<button><div onclick="${onWeighbridgeTest}('${params.data.uuid}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_Test')}</div></button>`
            }
          },
          {
            headerName: this.$t('SeaExport.Operation'),
            field: 'operation',
            suppressMenu: true,
            width: 140,
            cellRenderer: params => {
              const onAdd = this.documentManage.getPath('onAdd')
              const onDel = this.documentManage.getPath('onDel')
              return `<div>
                        <a onclick="${onAdd}('${params.data.uuid}')" style="color:#1F75D5;font-size:25px;">+</a>
                        <a onclick="${onDel}('${params.data.uuid}')" style="color:#1F75D5;font-size:25px;">-</a>
                      </div>`
            }
          }
        ],
        editRowData: [],
        editGridApi: null
      },
      cameraDialog: {
        visible: false,
        form: {
          uuid: '',
          airportCargoTerminalUuid: '',
          scaleIdentifier: '',
          baudRate: 9600,
          parityBit: 11,
          autoPhotoTaking: false,
          cameraInterfaceType: '',
          cameraAppKey: '',
          cameraDeviceNumber: '',
          cameraSecret: '',
          monitorChannel: ''
        }
      },
      cameraC: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          singleClickEdit: true,
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridCommonInputEditor
          }
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_MonitoringChannel'),
            field: 'channel',
            editable: true,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: false
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Remarks'),
            field: 'remark',
            editable: true,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: false
            }
          },
          {
            headerName: this.$t('SeaExport.Operation'),
            field: 'operation',
            suppressMenu: true,
            width: 140,
            cellRenderer: params => {
              const onAddC = this.documentManage.getPath('onAddC')
              const onDelC = this.documentManage.getPath('onDelC')
              return `<div>
                        <a onclick="${onAddC}()" style="color:#1F75D5;font-size:25px;">+</a>
                        <a onclick="${onDelC}(${params.data.serialNumber})" style="color:#1F75D5;font-size:25px;">-</a>
                      </div>`
            }
          }
        ],
        rowData: [],
        gridApi: null
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onAdd', function(value) {
      context.onAdd(value)
    })
    this.documentManage.set('onDel', function(value) {
      context.onDel(value)
    })
    this.documentManage.set('onCameraConfiguration', function(value) {
      context.onCameraConfiguration(value)
    })
    this.documentManage.set('onWeighbridgeTest', function(value) {
      context.onWeighbridgeTest(value)
    })
    this.documentManage.set('onAddC', function() {
      context.onAddC()
    })
    this.documentManage.set('onDelC', function(value) {
      context.onDelC(value)
    })
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    onWeighbridgeTest(uuid) {
      const rows = this.edit.editRowData.filter(p => p.uuid === uuid)
      if (!rows || rows.length === 0) {
        return
      }
      const row = rows[0]
      this.readScaleHandler(0, row.baudRate, row.parityBit)
    },
    // 读磅
    readScaleHandler(n, baudRate, parityBit) {
      const loading = getLoading()
      serial(baudRate, parityBit).then(res => {
        if (res === undefined && n < 5) {
          n++
          this.readScaleHandler(n, baudRate, parityBit)
        } else {
          if (res && res.code) {
            console.log(res)
            res = ''
          }
          if (!res || res === '0') {
            res = this.$t('CargoMsg.Cargo_ReadFailure')
          }
          const text = '<span style="font-size: 20px"> ' + res + ' </span>'
          this.$confirm(text, this.$t('CargoMsg.Cargo_ScaleReading'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Close'),
            showCancelButton: false,
            dangerouslyUseHTMLString: true,
            center: true
          })
        }
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    onCameraConfiguration(uuid) {
      const rows = this.edit.editRowData.filter(p => p.uuid === uuid)
      this.cameraDialog.form = rows[0]
      if (this.cameraDialog.form.monitorChannel) {
        this.cameraC.rowData = JSON.parse(this.cameraDialog.form.monitorChannel)
      } else {
        this.cameraC.rowData = []
        const rowData = {
          channel: '',
          remark: ''
        }
        this.cameraC.rowData.push(rowData)
      }
      this.cameraDialog.title = this.$t('CargoMsg.Cargo_CameraConfiguration')
      this.cameraDialog.visible = true
    },
    onAdd(uuid) {
      const newConfiguration = {
        uuid: this.addScaleKey + getUuid(),
        airportCargoTerminalUuid: uuid,
        scaleIdentifier: '',
        baudRate: 9600,
        parityBit: 11,
        autoPhotoTaking: false,
        cameraInterfaceType: '',
        cameraAppKey: '',
        cameraDeviceNumber: '',
        cameraSecret: '',
        monitorChannel: ''
      }
      this.edit.editRowData.push(newConfiguration)
    },
    onDel(uuid) {
      if (uuid !== null) {
        this.edit.editRowData = this.edit.editRowData.filter(row => row.uuid !== uuid)
      } else {
        const api = this.edit.editGridOptions.api
        const selRows = api.getSelectedRows() // 获取选中的行
        api.updateRowData({ remove: selRows })
        const rowData = []
        api.forEachNode(node => rowData.push(node.data))
        this.edit.editRowData = rowData
      }
      if (this.edit.editRowData.length === 0) {
        this.onAdd()
      }
    },
    onAddC() {
      const newConfiguration = {
        channel: '',
        remark: '',
        id: 'serialNumber_' + this.cameraC.rowData.length
      }
      this.cameraC.rowData.push(newConfiguration)
      ColumnUtils.addSerialNumber(this.cameraC.rowData)
    },
    onDelC(serialNumber) {
      if (serialNumber !== null) {
        this.cameraC.rowData = this.cameraC.rowData.filter(row => row.serialNumber !== serialNumber)
      } else {
        const api = this.cameraC.gridOptions.api
        const selRows = api.getSelectedRows() // 获取选中的行
        api.updateRowData({ remove: selRows })
        const rowData = []
        api.forEachNode(node => rowData.push(node.data))
        this.cameraC.rowData = rowData
      }
      if (this.cameraC.rowData.length === 0) {
        this.onAddC()
      } else {
        ColumnUtils.addSerialNumber(this.cameraC.rowData)
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getAirportCargoTerminalList(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: this.addKey + getUuid(),
          warehouseName: '',
          warehouseCode: '',
          airportCode: '',
          warehouseType: 0,
          orderType: '',
          securityMachineWidth: 0,
          securityMachineHeight: 0,
          warehouseAddress: '',
          deliveryMapUrl: '',
          receiverContact: '',
          receiverPhone: '',
          remarks: ''
        }
        this.edit.editRowData = []
        this.onAdd(this.editDialog.form.uuid)
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_GeneralCargoWarehouse')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        const form = { ...rows[0] }
        this.editDialog.form = form
        this.edit.editRowData = form.list
        if (this.edit.editRowData && this.edit.editRowData.length === 0) {
          this.onAdd(this.editDialog.form.uuid)
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_GeneralCargoWarehouse')
      }
      this.editDialog.visible = true
    },
    cameraSave() {
      const list = [...this.cameraC.rowData]
      this.cameraDialog.form.monitorChannel = JSON.stringify(list)
      this.cameraDialog.visible = false
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (form.uuid && form.uuid.indexOf(this.addKey) !== -1) {
        form.uuid = ''
      }
      if (!form.orderType) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PleaseFill') + self.$t('CargoMsg.Cargo_OrderType'))
        return
      }
      if (!form.airportCode) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PleaseFill') + self.$t('CargoMsg.Cargo_AirportCode'))
        return
      }
      if (!form.warehouseCode) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PleaseFill') + self.$t('CargoMsg.Cargo_TerminalCode'))
        return
      }
      if (!form.warehouseName) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PleaseFill') + self.$t('CargoMsg.Cargo_TerminalName'))
        return
      }
      if (!form.securityMachineWidth < 0) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PleaseFill') + self.$t('CargoMsg.Cargo_SecurityCheckMachineWidthLimit'))
        return
      }
      if (!form.securityMachineHeight < 0) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PleaseFill') + self.$t('CargoMsg.Cargo_SecurityCheckMachineHeightLimit'))
        return
      }
      form.list = this.edit.editRowData
      form.dataType = 1
      const loading = getLoading()
      saveAirportCargoTerminal(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      }).finally(() => loading.close())
    },
    uploadAttachment(uuid) {
      if (!uuid) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSaveCurrentDataFirst'))
        return
      }
      this.fileUpload.businessId = uuid
      this.fileUpload.parameters.uuid = uuid
      this.fileUpload.visible = true
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('CargoMsg.Cargo_DeleteTip1', [rows.length, self.$t('CargoMsg.Cargo_GeneralCargoWarehouse')]), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        self.syncRemove(rows, 0)
      }).catch(() => { })
    },
    syncRemove(rows, index) {
      const self = this
      if (index < rows.length) {
        delAirportCargoTerminal(rows[index].uuid).then(res => {
          self.syncRemove(rows, index + 1)
        }).catch(() => {
          if (index > 0) {
            self.filter.pageNum = 1
            self.toQuery()
          }
        })
      } else {
        self.filter.pageNum = 1
        self.toQuery()
        self.$message.success(self.$t('common.tips.deleteSuccess'))
      }
    }
  }
}
</script>

<style>
</style>
